import type { FaireProductEntity } from "../../entity_types/product";

export const p_yxguhauefg: FaireProductEntity = {
  token: "p_yxguhauefg",
  type: "product",
  name: "Hawaiian Soda Passion Orange Guava 12oz - Case of 12",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl: "https://cdn.faire.com/fastly/a09827eeacaa4f6359109b5d57a19bbe54722b0315efc4b559ce4cf4e81eb92e.jpeg",
  galleryImageUrls: [],
  priceDollars: 51.16,
  description: "Indulge in the tropical flavors of Everyday Supply Co's Hawaiian Soda Passion Orange Guava. Each 12oz can in this case of 12 is bursting with the sweet and tangy notes of passion fruit, orange, and guava. Perfectly carbonated, it's a beverage that transports you to the sunny shores of Hawaii. Enjoy it from the can or mix it into your favorite drink for a tropical twist. Everyday Supply Co brings you trusted, quality essentials that make every day better.",
  tags: [],
  msrpDollars: 102.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:12.175Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
